import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';
import {
  Observable,
  debounceTime,
  distinctUntilChanged,
  first,
  map,
  of,
  switchMap,
} from 'rxjs';
import {AddEmployeeService} from '../services/add-employee.service';

export const wordCountValidator = (maxCount: number) => {
  return (control: AbstractControl) => {
    if (!control.value) return null;
    const count = control.value.trim().replace(/  +/g, ' ').split(' ').length;
    return count <= maxCount ? null : {wordCount: true};
  };
};

export const uniqueEmailValidator = (
  service: AddEmployeeService
): AsyncValidatorFn => {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.value) {
      return of(null);
    }
    return control.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(2000),
      switchMap(email => {
        return service
          .checkEmployeeEmail(email)
          .pipe(map(result => (result ? null : {notUnique: true})));
      }),
      first()
    );
  };
};

export const minNotInclude = (min: number) => {
  return (control: AbstractControl) => {
    if (control.value === null) return null;
    const count = Number(control.value);
    return count > min ? null : {min: true};
  };
};
